import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionAccountingStateForm_MissionAccounting_ActionPermissions_QueryDocument =
  graphql(`
    query MissionAccountingStateForm_MissionAccounting_ActionPermissions_Query(
      $id: Id!
    ) {
      findOneMission(id: $id) {
        access {
          actions(part: "accounting") {
            ...FolderBusinessEntityStateForm_ActionPermission_Fragment
          }
        }
      }
    }
  `);

export type MissionAccountingStateForm_MissionAccounting_ActionPermissions =
  ResultOf<
    typeof MissionAccountingStateForm_MissionAccounting_ActionPermissions_QueryDocument
  >['findOneMission'];

export const useFindAllMissionAccountingInfoActionPermissionsQuery = (
  id = EMPTY_ID,
  enabled = !!id,
) =>
  useGraphQLQuery(
    MissionAccountingStateForm_MissionAccounting_ActionPermissions_QueryDocument,
    { id },
    { enabled: !!id && enabled },
  );
